import { getApi, putApi, OK} from "@/util";

const state = {
	apiStatus: null,
	calendarData: null,
	calendarCompareData: null,
	calendarDayData: null,
	calendarSearchData: null,
}

const mutations = {
	setApiStatus (state, status) {
		state.apiStatus = status
	},
	setCalendarData(state, data) {
		state.calendarData = data
	},
	setCalenderCompareData(state, data) {
		state.calendarCompareData = data
	},
	setCalendarDayData(state, data) {
		state.calendarDayData = data
	},
	setCalendarSearchData(state, data) {
		state.calendarSearchData = data
	},
}

const actions = {
	async calendarGetApi(context, data) {
		context.commit('setApiStatus', null)
		if (data.next_data !== null && data.prev_data !== null) {
			const response = await getApi('calendar_web', data.next_data)
			const response_compare = await getApi('calendar_web', data.prev_data)

			// 正常処理
			if (response.status === OK && response_compare.status === OK) {
				context.commit('setApiStatus', true)
				context.commit('setCalendarData', JSON.parse(response.data))
				context.commit('setCalenderCompareData', JSON.parse(response_compare.data))
				return false
			}

			// エラー処理(共通)
			context.commit('setApiStatus', false)
			if (response.status !== OK) {
				context.commit('error/setStatusCode', response.status, { root: true })
				context.commit('error/setMessage', response.message, { root: true })
			}
			if (response_compare.status !== OK) {
				context.commit('error/setStatusCode', response_compare.status, { root: true })
				context.commit('error/setMessage', response_compare.message, { root: true })
			}
		}
		else {
			const response_compare = await getApi('calendar_web', data.prev_data)

			// 正常処理
			if (response_compare.status === OK) {
				context.commit('setApiStatus', true)
				context.commit('setCalenderCompareData', JSON.parse(response_compare.data))
				return false
			}

			// エラー処理(共通)
			context.commit('setApiStatus', false)
			context.commit('error/setStatusCode', response_compare.status, { root: true })
			context.commit('error/setMessage', response_compare.message, { root: true })
		}
	},
	async calendarDayGetApi(context, data) {
		context.commit('setApiStatus', null)
		const response = await getApi('calendar_detail_web', data)

		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			context.commit('setCalendarDayData', JSON.parse(response.data))
			return false
		}

		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
	async updateCalendarApi(context, data) {
		context.commit('setApiStatus', null)
		const response = await putApi('calendar_list', data)

		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			return false
		}

		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
	async searchCalendarApi(context, data) {
		context.commit('setApiStatus', null)
		const response = await getApi('calendar_search_web', data)

		// 正常処理
		if (response.status === OK) {
			context.commit('setApiStatus', true)
			context.commit('setCalendarSearchData', JSON.parse(response.data))
			return false
		}

		// エラー処理(共通)
		context.commit('setApiStatus', false)
		context.commit('error/setStatusCode', response.status, { root: true })
		context.commit('error/setMessage', response.message, { root: true })
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}

export function dispCalendarInformationLength() {
	return parseInt(screen.width * 0.855 / 28) * 2
}
